import Rebase from 're-base'
import firebase from 'firebase'

const firebaseApp = firebase.initializeApp(
  {
    apiKey: "AIzaSyDtEuTOSvnFhYFNFH7XAqxlMo8rkg7ZMCE",
    authDomain: "catch-of-the-day-1-9e95e.firebaseapp.com",
    databaseURL: "https://catch-of-the-day-1-9e95e.firebaseio.com"
  }
)

const base = Rebase.createClass(firebaseApp.database())


export { firebaseApp };

export default base;


// WEBPACK FOOTER //
// ./src/base.js